export const RESET = 'EXSBINVOICETYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBINVOICETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBINVOICETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBINVOICETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBINVOICETYPE_LIST_TOGGLE_LOADING'
